import { configureStore } from '@reduxjs/toolkit'
import AuthenticationReducer from '../Redux/Features/Auth/AuthenticationSlice';
import SimulationServicesSlice from './Features/Simulation/SimulationServicesSlice';
import OnlineAPISlice from './Features/OnlineAPI/OnlineAPISlice';

export default configureStore({
  reducer: {
    auth: AuthenticationReducer,
    simulation: SimulationServicesSlice,
    onlineapi: OnlineAPISlice
  },
})